export interface SpinnerProps {
  size?: number;
  /** Accessible label announced to screen readers. */
  label?: string;
  className?: string;
}

/** An indeterminate loading spinner with an accessible live label. */
export function Spinner({ size = 22, label = 'Loading', className }: SpinnerProps) {
  return (
    <span
      className={['pt-spinner', className].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      <span className="pt-visually-hidden">{label}</span>
    </span>
  );
}
